const branchdefinitionList = [
  {
    branchCode: "001",
    branchName: "Şişli",
    province: "İstanbul",
    taxAdministration: "ŞİŞLİ",
    eMail: "abc@gmail.com",
  },
  {
    branchCode: "002",
    branchName: "Pendik",
    province: "İstanbul",
    taxAdministration: "PENDİK",
    eMail: "abcde21@gmail.com",
  },
];
export default branchdefinitionList;
